angular.module('app').controller('CommunicationCtrl', function($controller, $scope, $rootScope, $http, $location, $mdToast, $route, $interval, $mdDialog) {
    "ngInject";

    var main = this;

    main.name = 'communication';

    main.recipient_type = $route.current.params.recipient_type || 'event';
    main.school_id = $route.current.params.school_id;
    main.event_signup_id = $route.current.params.event_signup_id;
    main.customer_id = $route.current.params.customer_id;
    main.is_invoice = $route.current.params.invoice;
    main.defaults = {
        'intended_recipients': [{}],
        'base_template': 'Blank'
    }

    main.checkRecipientType = function() {
        if(main.item.recipient_group == 'Send to Individuals') {
            main.recipient_type = 'individual';
        } else {
            main.recipient_type = 'event';
        }
    }

    main.stats = {};

    main.isAfterHoursTime = function() {
        if (!main.item.send_sms) {
            return false;
        }
        
        // Use moment.js to check time in franchise timezone
        var now = moment().tz(main.franchiseTimezone);
        var hour = now.hour();
        
        // Check if time is between 8PM (20) and 9AM (9)
        return hour >= 20 || hour < 9;
    };
    
    main.showAfterHoursConfirmation = function(event) {
        return $mdDialog.confirm()
            .title('Send SMS After Hours?')
            .textContent('You are sending an SMS message between 8PM and 9AM in the franchise timezone. Are you sure you want to proceed?')
            .ariaLabel('After hours SMS confirmation')
            .targetEvent(event)
            .ok('Send Anyway')
            .cancel('Cancel');
    };
    
    main.afterSave = function($rootScope, response) {
        $location.url('/communication/' + response.data.id);
        var message = "Communication queued. Job ID" + response.data.job_id;
        var alert = $mdToast.simple().textContent(message);
        $mdToast.show(alert);
    };

    main.loadRecipientDetails = function(recipient) {
        $http.get('/api/v1/admin/communication/' + main.item.id + '/log/' + recipient.id).then(function(response) {
            main.stats[recipient.id] = response.data;
        });
    };

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.loadFranchiseData = function() {
        var franchise_id = $rootScope.franchiseSwitcher.activeFranchise();
        $http.get('/api/v1/admin/franchise/' + franchise_id).then(function(response) {
            main.item.from_name = response.data.default_from_name;
            main.item.from_address = response.data.default_from_address;
            main.franchiseTimezone = response.data.timezone || 'US/Central';
            if(main.item.order_id) {
                if(main.is_invoice) {
                    main.template = response.data.default_invoice
                } else {
                    main.template = response.data.default_order_receipt
                }
            } else {
                main.template = response.data.default_email_template;
            }
            main.updateTemplate(main.template);
        });
    }

    if(main.id == 'new') {
        if($rootScope.franchise_id) {
            main.loadFranchiseData();
        } else {
            $scope.$on('permissions-saved', main.loadFranchiseData);
        }

        if(main.event_signup_id) {
            $http.get('/api/v1/admin/event_signup/' + main.event_signup_id).then(function(response) {
                var users = response.data.subject.user_subjects.map(function(us) {
                    return us.user;
                });
                main.item.intended_recipients = response.data.contacts.concat(users);
            });
        }

        if(main.customer_id) {
            $http.get('/api/v1/admin/user/' + main.customer_id).then(function(response) {
                main.item.intended_recipients = [response.data];
            });
        }

        if(main.item.order_id) {
            $http.get('/api/v1/admin/orders/' + main.item.order_id).then(function(response) {
                main.item.invoice_amount = response.data.balance_due;
                main.item.intended_recipients = [
                    response.data.user
                ]
            });
        }

        if(main.item.school_id) {
            $http.get('/api/v1/admin/school/' + main.item.school_id).then(function(response) {
                main.item.intended_recipients = response.data.contacts;
                main.item.intended_recipients.forEach((contact) => {
                    if(contact.phone & !contact.cell_phone) {
                        contact.cell_phone = contact.phone;
                    }
                });
            });
        }
    };

    main.updateTemplate = function(template) {
        main.item.body_html = template.body_html;
        main.item.sms_body = template.sms_body;
        main.item.send_sms = template.send_sms;
        main.item.recipient_group = template.default_recipients
        main.item.base_template = template.base_template
        main.item.subject = template.subject
    }

    main.isComplete = function() {
        var done = ['sent', 'error'];
        return done.includes(main.item.status);
    }

    main.queueCheck = false;
    $scope.$on('model-loaded', function() { 
        console.log('loaded', main.item.status, main);
        if(!main.queueCheck && !main.isComplete()) {
            console.log('adding interval');
            main.queueCheck = $interval(() => {
                console.log('checking');
                main.load().then(null, function(response) {
                    $interval.cancel(main.queueCheck);
                });
            }, 10000);
        } else if (main.queueCheck && main.isComplete()) {
            console.log('canceling');
            $interval.cancel(main.queueCheck);
        }
    });

    main.preview = function() {
        $rootScope.util.quickDialog(
            'PreviewCommunicationCtrl',
            'preview-communication.html',
            { item: main.item, type:  main.recipient_type }
        );
    }
    
    main.save = function(event) {
        if (main.isAfterHoursTime()) {
            $mdDialog.show(main.showAfterHoursConfirmation(event))
                .then(function() { main._save(); })
                .catch(function() {
                    // User clicked "Cancel" Do nothing
                });
        } else {
            main._save();
        }
    };

});
